<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      v-if="items.length > 0"
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card  class="mt-2" >
        
        <h1>{{ $t("BookingInformation") }}</h1>
        <br />
        <div class="export-table mt-5 ml-2 user-detail-table">
          <div class="vx-col">
            <b-table-simple responsive>
              <b-tbody>
                
                <b-tr
                  v-for="(item, index) in items"
                  :key="item.id"
                >
               
                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <span class="font-semibold">
                      {{ item.question }}
                    </span>
                  </b-td>

                  <b-td
                    vs-type="flex"
                    vs-justify="left"
                    vs-align="left"
                    vs-w="6"
                  >
                    <template v-if="item.type == 'file' && item.answers.length">
                      
                      <h6
                        class="text-primary"
                        v-for="(answer, aindex) in item.answers"
                        :key="answer.id"
                      >
                        <p>
                        
                          <feather-icon
                            v-if="answer.answer"
                            @click.prevent.stop="getFile(answer.answer_label, answer.answer)"
                            id="export"
                            icon="DownloadCloudIcon"
                            svgClasses="w-5 h-5 hover:text-success stroke-current"
                            class="ml-2"
                            style="top: 4px"
                            title="Download"
                          />
                       
                          <input
                            type="file"
                            style="display: none"
                            :name="answer.answer_label"
                            @change="
                              replaceAnswerDoc(answer,item.question, answer.answer_label, $event)
                            "
                            :ref="`qa_file_input-${index}`"
                          />
                          <feather-icon
                            @click.prevent.stop="
                              $refs[`qa_file_input-${index}`][aindex].click()
                            "
                            icon="UploadCloudIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            class="ml-2"
                            style="top: 4px"
                            title="Upload and Replace"
                          />
                          <template v-if="answer.answer">
                            <feather-icon
                              @click.prevent.stop="
                                deleteAnswerDoc(index, aindex)
                              "
                              icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2"
                              style="top: 4px"
                              title="Delete"
                            />
                            <feather-icon
                              v-if="previewLinks[answer.answer]"
                              @click.prevent.stop="
                                showPreview(previewLinks[answer.answer], !answer.answer.includes('.pdf') ? 'image' : 'other')
                              "
                              icon="ZoomInIcon"
                              svgClasses="w-5 h-5 hover:text-warning stroke-current"
                              class="ml-2"
                              style="top: 4px"
                              title="Zoom In"
                            />
                            <feather-icon
                            
                              @click.prevent.stop="
                                rejectedFlag(answer)
                              "
                              icon="XIcon"
                              svgClasses="w-5 h-5 hover:text-warning stroke-current"
                              class="ml-2"
                              style="top: 4px"
                              title="Reject"
                            />
                          </template>
                        </p>
                        <template v-if="answer">
                  
                          <p v-if="rejectReasons && rejectReasons[answer.id] && rejectReasons[answer.id].isRejected"
                          >
                          
                            <textarea
                              v-model="rejectReasons[answer.id]['rejection_reason']"
                              :placeholder="$t('QADocRejectReason')"
                              :name="answer.answer_label"
                              class="w-full"
                            ></textarea>
                          </p>
                          <template v-if="previewLinks[answer.answer]">
                            <img
                              v-if="!answer.answer.includes('.pdf')"
                              class="custom-image-class"
                              :src="previewLinks[answer.answer]"
                              width="400"
                            />
                            <iframe
                              v-else
                              class="custom-image-class"
                              :src="previewLinks[answer.answer]"
                              width="400"
                              height="300"
                              style="border: none"
                            />
                          </template>
                          <template v-if="answer.status == -1">
                            <p>
                              <span class="text-danger">{{ $t('Rejected') }}</span>
                            </p>
                            <!-- <p>
                              <span class="text-disable">{{ answer.rejection_reason }}</span>
                            </p> -->
                          </template>
                        </template>
                        <br />
                      </h6>
                    </template>
                    <h6 v-else-if="item.type == 'checkbox'"> {{ item.answer }}</h6>
                    <h6 v-else>
                      {{ item.answers[0] ? item.answers[0].answer : 'N/A' }}
                    </h6>
                  </b-td>
                </b-tr>
                <b-tr v-if="showSendEmail">
                  <b-td colspan="2">
                    <b-button
                      variant="primary"
                      @click.prevent.stop="rejectSubmit()"
                      class="ml-1 br-20 float-right btn-primary:focus"
                      >{{ $t("SendEmail") }}</b-button
                    >
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <a
              href="http://"
              class="hide"
              ref="adownload"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </div>
        </div>
      </b-card>
    </b-overlay>
    
    <ShowFilePreview :previewModal="previewModal"></ShowFilePreview>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { getFile } from "@/api/staff";
import ShowFilePreview from "@/components/show-file-preview.vue";
import {
  removeQaDocFile,
  replaceQaDocFile,
  rejectQaDocsFile,
  get,
} from "@/api/company-users";
import {

  staffUserUpdate,
 
} from "@/api/appointment.js";
import { getUserDocumentsById, deleteAnswerByStaff, rejectAnswerByStaff } from '@/api/appointment';
import { getErrorMessage, parseStringToURLFriendly } from "@/utils/helper";
export default {
  props: {
    user: [Object],
    user_id: [],
      appointment_id: [],
  },
  components: {
    vSelect, ShowFilePreview
  },
  data() {
    return {
      items: [],
      previewModal: {
        show: false,
        link: '',
        type: 'image'
      },
      previewQAdoc: false,
      previewLinks: {},
      rejectReasons: {},
      images: "",
      path: "",
      type: "",
      ext: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      recordNotFound: false,
    };
  },
  computed: {
    showSendEmail() {
      for(let answer_id in this.rejectReasons) {
        if(this.rejectReasons[answer_id].isRejected)
          return true;
      }
      return false;
    },
  },
  watch: {
    items() {
      this.loadPreviewFiles();
      this.setRejectReason();
    },
    "user.question_option_field": {
      handler: function (qof) {
        this.loadPreviewFiles();
      },
    },
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.getAnswers();
    console.log(this.user);
    this.loadPreviewFiles();
  },
  methods: {
    rejectedFlag(data){
      return this.rejectReasons[data.id]['isRejected']=!this.rejectReasons[data.id]['isRejected'];
    },
    async getAnswers() {
      const res = await getUserDocumentsById({user_id: this.user_id, params: {map: "raw",appointment_id: this.appointment_id,}});
      this.items = res.data.data
      .map(f => {
        if(f.type == 'checkbox')
          f.answer = f.answers.map(a => a.answer).join(', ');
        return f;
      });
      console.log(res);
    },
    loadPreviewFiles() {
      this.items
      .filter(item => item.type == 'file')
      .forEach(item => {
        item.answers.forEach(answer => {
          if(answer.answer != null && answer.answer != "") {
            this.showFile(
              answer.answer,
              !answer.answer.includes(".pdf") ? "image" : "pdf"
            );
          }
        })
      });
    },
    setRejectReason() {

      const rejectReasons = {};
      this.items.filter(item => item.type == 'file')
      .forEach(item => {
        item.answers
        .forEach(answer => {
          if(answer.status != -1) {
            rejectReasons[answer.id] = {isRejected: false, rejection_reason: ''}
          }
        })
      });
      this.rejectReasons = rejectReasons;
      return;

      const qof = this.user.question_option_field;
      if(qof == null) return;
      if(Array.isArray(qof) == false) return;

      this.rejectReasons = qof.map((q, i) => {
        const t = {
          question: q.question,
          answer: {},
        };

        if(q.type != 'files')
          return t;
        
        for (let answer in q.answer) {
          t.answer[answer] = { reason: "", isRejected: false };
        }
        return t;
      });
    },
    showPreview(link, type='image') {
      this.previewModal.show = true;
      this.previewModal.link = link;
      this.previewModal.type = type;
    },
    async rejectSubmit() {
      this.show = true;
      try {
        const res = await rejectAnswerByStaff({
          rejectReasons: this.rejectReasons,
        });
          this.$toasted.show(this.$t("RejectUserFile"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
             this.getAnswers();
          // this.$set(
          //   this.user,
          //   "question_option_field",
          //   JSON.parse(res.data.data)
          // );
        console.log("rejectSubmit", res);
      } catch (error) {
           this.catchMethod(error);
      }

      this.show = false;
    },
    async replaceAnswerDoc(data,question, key, event) {
      this.show=true;
     
      try {
        const isOk = await this.$swal({
          title: this.$t("ReplaceQaDocument"),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("Yes"),
          confirmButtonColor: "#7367F0",
          cancelButtonText: this.$t("No"),
          showCloseButton: true,
          showLoaderOnConfirm: true,
              onClose: this.removed() 
        });
        if (!isOk.value) {
          return false;
           this.show = false;
        }
        this.show = false;
        const fd = new FormData();
         fd.append("appointment_question_answer_id", data.id);
        fd.append("question", question);
        fd.append("key", key);
        fd.append("file", event.target.files[0]);

        const res = await staffUserUpdate(data.appointment_question_id, fd);
        console.log("replaceQaDocFile:res", res);
        // this.$set(
        //   this.user,
        //   "question_option_field",
        //   JSON.parse(res.data.data)
        // );
        
                  this.$toasted.show(this.$t("UpdateUserFile"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
            this.getAnswers();
      } catch (error) {
          this.catchMethod(error);
      }
    },
    removed(){
      this.show=false;
    },
    async deleteAnswerDoc(question_idx, answer_idx) {
      this.show=true;
      try {
        const isOk = await this.$swal({
          title: this.$t("DeleteQaDocument"),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("Yes"),
          confirmButtonColor: "#7367F0",
          cancelButtonText: this.$t("No"),
          showCloseButton: true,
          showLoaderOnConfirm: true,
          onClose: this.removed()        // Removed () from here
        });
        if (!isOk.value) return false;

        const res = await deleteAnswerByStaff(
          this.items[question_idx].id,
          this.items[question_idx].answers[answer_idx].id
        );
        
        this.items[question_idx].answers.splice(answer_idx, 1);
        this.$toasted.show(this.$t("DeleteUserFile"), {
          className: "top-alert",
          position: "top-center",
            type: "success",
            duration: 2000,
          });
               this.getAnswers();
          
        } catch (error) {
          this.catchMethod(error);
        }
        this.show=false;
      
    },
    catchMethod(error){
 
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
    },
    formatAns(item) {
      if (item.type == "checkbox") {
        var val = JSON.parse(item.answer);
        if (Array.isArray(val)) {
          return val.join(", ");
        } else {
          return val;
        }
      } else return JSON.parse(item.answer);
    },
    async showFile(filename, type) {
      if (this.previewLinks[filename]) return;

      const response = await getFile(`appointment-documents/${filename}`);
      let url = URL.createObjectURL(response.data);

      if (type == "pdf") url = `${url}#toolbar=0`;
      this.$set(this.previewLinks, filename, url);
    },

    async getFile(key, filename) {
      this.show = true;
      const ext = filename.split(".").pop();
      console.log(key);
      console.log(filename);
      const response = await getFile(`appointment-documents/${filename}`);
      const url = URL.createObjectURL(response.data);
      console.log(url);
      const el = this.$refs.adownload;
      const fileName = parseStringToURLFriendly(
        `${key} ${this.user.first_name} ${this.user.last_name}`
      );
      el.download = `${fileName}.${ext}`;
      el.href = url;
      el.click();
      URL.revokeObjectURL(url);
      this.show = false;
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    setAnswer(answer) {
      if (typeof answer == "object") {
        return Object.keys(answer)
          .map(function (k) {
            return answer[k];
          })
          .join(", ");
      }
      return answer;
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.b-row {
  padding: 10px;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-image-class {
  box-shadow: 0px 0px 4px #888;
  padding: 5px;
}

.user-detail-table td {
  white-space: normal;
}

.user-detail-table td:first-child {
  min-width: 300px;
}

.user-detail-table td:nth-child(2) {
  min-width: 600px;
}

@media (max-width: 1024px) {
  .user-detail-table td:first-child {
    min-width: 250px;
  }

  .user-detail-table td:nth-child(2) {
    min-width: 400px;
  }
}

@media (max-width: 768px) {
  .user-detail-table td:first-child {
    min-width: 100px;
  }

  .user-detail-table td:nth-child(2) {
    min-width: 200px;
  }

  .user-detail-table img, iframe {
    width: 100%;
  }

  .user-detail-table iframe {
    height: 200px;
  }
}
</style>